import { render, staticRenderFns } from "./Coding.vue?vue&type=template&id=7389bbec&scoped=true&"
var script = {}
import style0 from "./Coding.vue?vue&type=style&index=0&id=7389bbec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7389bbec",
  null
  
)

export default component.exports